import { render, staticRenderFns } from "./SuperadminUserIcon.vue?vue&type=template&id=0222f6dc&scoped=true&"
import script from "./SuperadminUserIcon.vue?vue&type=script&lang=js&"
export * from "./SuperadminUserIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222f6dc",
  null
  
)

export default component.exports